import { PriceOption } from '@/components/Product/ProductQtyRow'

const resolveMaxQuantity = (option: PriceOption) => {
  if (typeof option.maxQuantity === 'number' && option.maxQuantity > 0) {
    return option.maxQuantity
  }
  return Infinity
}

const findCompatiblePriceOption = (
  priceOptions: PriceOption[],
  quantity: number
): PriceOption | undefined => {
  if (!priceOptions.length) {
    return undefined
  }

  const sorted = [...priceOptions].sort((a, b) => Number(a.quantity) - Number(b.quantity))

  const directMatch = sorted.find(option => {
    const min = Number(option.quantity)
    const max = resolveMaxQuantity(option)
    return quantity >= min && quantity <= max
  })

  if (directMatch) {
    return directMatch
  }

  const lowerOrEqual = sorted.filter(option => quantity >= Number(option.quantity))
  if (lowerOrEqual.length) {
    return lowerOrEqual[lowerOrEqual.length - 1]
  }

  return sorted[0]
}

export default findCompatiblePriceOption
